<template>
  <vs-select
    v-model="status"
    :placeholder="$t('message.status')"
    style="width: 100px"
  >
    <vs-select-item value="pending" :text="$t('message.pending')" />
    <vs-select-item value="approved" :text="$t('message.approved')" />
    <vs-select-item value="on hold" :text="$t('message.onHold')" />
  </vs-select>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      status: this.data,
    };
  },
  watch: {
    status(newVal) {
      this.$emit("update", newVal);
    },
  },
};
</script>
